import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.sass'],
})
export class SubMenuComponent implements OnInit {
  @Input('menu') menu: any;
  @Output() onItemClick = new EventEmitter<void>();

  private readonly exactOptions = { exact: true };
  private readonly inexactOptions = { exact: false };
  private readonly commandsCache = new Map<string, string[]>();

  constructor() { }

  ngOnInit(): void { }

  handleItemClick() {
    this.onItemClick.emit();
  }

  isExactLink(item: any): boolean {
    const link = item?.routerLink || '';
    if (!link || !this.menu?.children) {
      return false;
    }

    return this.menu.children.some((sibling: any) =>
      sibling?.routerLink &&
      sibling.routerLink !== link &&
      sibling.routerLink.startsWith(`${link}/`)
    );
  }

  getActiveOptions(item: any): { exact: boolean } {
    return this.isExactLink(item) ? this.exactOptions : this.inexactOptions;
  }

  getRouterCommands(item: any): string[] {
    const link = item?.routerLink || '';
    const cached = this.commandsCache.get(link);
    if (cached) {
      return cached;
    }
    const commands = link.split('/').filter((segment: string) => !!segment);
    this.commandsCache.set(link, commands);
    return commands;
  }
}
